<template>
  <!-- 空白版型：不含任何 header/footer -->
  <div>
    <slot />
  </div>
</template>
